<template>
    <wrap>
        <template #sidebar>
            <section class="sidebar-section">
                <el-button class="el-button--w100" size="large" type="primary" @click="addNewAnn()" :disabled="permissionCantPublish">
                    <svg-icon name="pen2" style="margin-right: 8px;" /> New
                </el-button>

                <el-button v-for="(item, index) in sidebarList" :class="['el-button--w100 nav-btn']" size="large"
                    :text="whichType !== item.type" :key="index" @click="clickWhcihType(item.type)">
                    <svg-icon :name="item.icon" />
                    <p>{{ item.name }}</p>
                    <svg-icon class="arrow-svg" name="arrow" />
                </el-button>
            </section>
        </template>
        <template #main>
            <div class="announcements-wrap">
                <header class="announcements-header">
                    <h2>
                        <span>{{ AnnTitle }}</span>
                        <queue-progress v-if="announcementsYes" :isStatic="true" />
                    </h2>
                    <Alert v-if="!announcementsYes" svgName="lock" className="yellow">
                        <p>
                            Your current plan does not have access to this feature. 
                            <a :href="`mailto:${$store.state.mail_to_creator}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade to Custom Subdomain&body= Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a> 
                            to upgrade your account
                        </p>
                    </Alert>
                </header>
                <div class="announcement-content">
                    <AnnouncementsTable :which-type="whichType" :key="whichType"/>
                </div>
            </div>
        </template>
    </wrap>
</template>

<script setup>
import Wrap from '@/components/messaging/Wrap.vue';
import AnnouncementsTable from '@/components/messaging/Announcements/AnnouncementsTable.vue';
import { ref, onMounted, computed } from 'vue';
import { ElButton } from 'element-plus';
import emitter from '@/utils/EventBus';
import { useRouter } from 'vue-router';
import Store from '@/store/index.js';
import Alert from '@/components/settings/SettingAlert.vue';

const router = useRouter();
const whichType = ref('1');//1 for draft, 2 for scheduled, 3 for published
const sidebarList = ref([
    { name: 'Draft', type: '1', icon: 'draft' },
    { name: 'Scheduled', type: '2', icon: 'scheduled' },
    { name: 'Published', type: '3', icon: 'send' },
    { name: 'Archived', type: '4', icon: 'package' }
]);
const drawer = ref(false);

const AnnTitle = computed(() => {
    switch (whichType.value) {
        case '1':
            return 'Drafted Announcements';
        case '2':
            return 'Scheduled Announcements';
        case '3':
            return 'Published Announcements';
        case '4':
            return 'Archived Announcements';
    }
});
const permission_mes = computed(() => {
    return Store.state.user_data?.permission_list?.messagesAndAnnouncements;
});
const permissionCantPublish = computed(() => {
    return permission_mes.value.draftAndScheduleAndPublishAnnouncements.permission === 0;
});
const announcementsYes=computed(() => {
  return Store.state.user_data?.merchant_account?.is_enable_announcement;
});
//+++++++++++++++++++++++++++++++++++++
// Methods
//+++++++++++++++++++++++++++++++++++++
const addNewAnn = () => {
    emitter.emit('open-edit-announcement', { title: 'New Announcement', type: whichType.value, is_view:false });
};

const clickWhcihType = (type) => {
    whichType.value = type;
};

//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
onMounted(() => {
if(permission_mes.value?.manageAnnouncements.permission === 0){
    router.push('/creator/list');
}
});
</script>

<style lang="scss">
.sidebar-section {
    padding: 8px 16px 16px;
    display: grid;
    gap: 12px;

    .nav-btn {
        margin: 0;
        padding-left: 12px;
        padding-right: 12px;

        & > span {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            gap: 8px;
            color: var(--Text-brand);

            p {
                font: var(--medium-14);
                text-align: left;
                width: 100%;
            }
        }

        svg {
            height: 20px;
            width: 20px;
            fill: var(--Text-brand);
        }

        &.is-text {
            span {
                color: var(--text-secondary);

                svg {
                    fill: var(--text-secondary);
                }
            }

        }

        .arrow-svg {
            transform: rotate(-90deg);
            width: 12px;
            height: 12px;
        }
    }
}

.announcements-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0;

    .announcements-header {
        padding: 16px 0;
        display: flex;
        align-items: center;
        gap: 16px;
        h2{

            flex:1;
            display: flex;
            align-items: center;

            &>span{
                font: var(--font-demi-24);
                color: var(--black-90);
            }
        }
        .yellow {
            margin-bottom: 0;
        }
    }

    .announcement-content {
        flex: 1;
        overflow-y: auto;
        max-height: calc(100vh - 96px);
    }
}
</style>